type CertProps = {
  issueDate: String;
  issuedTo: String;
};

export const Certificate = ({
  issueDate,
  issuedTo,
}: CertProps): JSX.Element => {
  return (
    <div className="cert-container">
      <div className="cert bg-contain">
        <div className="cert-content">
          <div className="cert-header">
            <img
              src="https://res.cloudinary.com/dx6dieevo/image/upload/f_auto,q_auto:good,w_auto/v1724838523/pixa-pie/certificate/taoenze9vpsz00tgqfhd.png"
              alt="certificate header 1"
              className="object-contain max-md:max-h-[9px] max-h-[20px]"
            />
            <span className="cert-title font-modern">Birth Certificate</span>
            <img
              src="https://res.cloudinary.com/dx6dieevo/image/upload/f_auto,q_auto:good,w_auto/v1724838523/pixa-pie/certificate/xzwv31rlpnsofpzu44md.png"
              alt="certificate header 2"
              className=" object-contain max-md:max-h-[9px] max-h-[20px]"
            />
          </div>
          <div className="cert-body">
            <div className="cert-subtitle text-[#646363] mt-[1%]">
              This certificate grants
            </div>
            <div className="cert-name font-gochi text-[#152056]">
              {issuedTo}
            </div>
            <div className="cert-underline"></div>
            <div className="cert-description text-[#646363]">
              holds complete parental rights and responsibilities for Pixa, born
              on <b>{issueDate}</b>, at Pixa AI Labs. Pixa is known for its
              cuddly vibes and boundless curiosity
            </div>
            <div className="cert-message text-[#646363] font-[700]">
              "Treat Pixa with care and watch as your bond grows!"
            </div>
          </div>
          <div className="cert-footer">
            <div className="cert-footer-item">
              <span className="cert-date font-just text-[#2E3341] font-semibold ">
                {issueDate}
              </span>
              <div className="cert-underline"></div>
              <span className="cert-label">Date</span>
            </div>
            <div className="cert-footer-item">
              <img
                src="https://res.cloudinary.com/dx6dieevo/image/upload/f_auto,q_auto:good,w_auto/v1724843312/pixa-pie/certificate/sr3h3gngin25dsmcceew.png"
                alt="seal"
                className="cert-seal"
              />
            </div>
            <div className="cert-footer-item">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 76 32"
                className="cert-signature"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M14.1067 31.766C10.2894 31.6553 6.36144 30.4935 3.81658 27.8933L2.71012 28.6126L2.54416 28.3359L3.59531 27.6167C2.82078 26.7869 2.21224 25.8464 1.76965 24.7399C0.10996 20.4247 1.99092 15.8329 3.26335 13.5093C8.24242 4.43636 19.2517 -0.764004 29.4312 1.11698C30.3164 1.28295 31.2568 1.55957 31.8654 2.27877C32.6399 3.21926 32.3633 4.65766 32.142 5.37686C31.1462 8.69625 28.1588 10.9645 25.0053 13.1774L24.6734 13.3987C26.3331 14.0626 27.6608 15.0031 28.546 16.2202C30.095 18.3225 30.261 21.3652 29.2099 24.0207C31.8101 24.1867 34.4656 24.0761 37.0104 23.3015C41.215 22.0844 45.4195 18.1565 44.977 13.3434V13.2327C44.9216 12.6795 44.8663 12.0156 45.2536 11.573C45.6962 11.0751 46.4154 11.0751 47.0792 11.1305C56.5948 12.0156 66.221 13.1774 75.6259 14.6158L75.5706 14.9478C66.1657 13.5094 56.5395 12.3476 47.0792 11.4624C46.4707 11.4071 45.8621 11.4071 45.5302 11.7943C45.2536 12.1263 45.2536 12.6795 45.3089 13.1774L45.3642 13.3434C45.7515 18.2671 41.4363 22.3611 37.1211 23.6888C34.5209 24.4633 31.7547 24.574 29.0439 24.3527C28.6567 25.1825 28.1587 26.0124 27.5502 26.7316C24.784 29.885 20.5795 31.1021 17.5367 31.5447C16.4303 31.7106 15.2685 31.766 14.1067 31.766ZM4.09319 27.6721C7.30193 30.9361 12.8896 31.8766 17.4814 31.2127C20.4688 30.7701 24.5627 29.6084 27.2736 26.5103C27.8637 25.8464 28.3431 25.1088 28.712 24.2973C26.7757 24.1867 24.8947 23.8548 23.1243 23.5782C21.1327 23.2462 18.8645 22.9143 17.0388 21.6972C16.3749 21.3099 15.7111 20.7014 15.2132 19.9822L4.09319 27.6721ZM25.7798 1.06165C16.8728 0.840362 7.91051 5.76413 3.59531 13.6753C2.32288 15.9436 0.441885 20.3694 2.10158 24.574C2.54416 25.6804 3.0974 26.5656 3.87192 27.3954L15.0472 19.6502C14.3833 18.5991 14.0514 17.382 14.3833 16.1649C15.1578 13.1774 19.0304 12.0709 22.3498 12.6795C23.0506 12.827 23.696 13.0114 24.2861 13.2327L24.784 12.9008C27.9375 10.6879 30.8143 8.47495 31.8101 5.26621C32.0314 4.60233 32.2526 3.3299 31.5888 2.44473C31.0909 1.83618 30.2057 1.61489 29.3758 1.44892C28.1956 1.22763 26.997 1.09854 25.7798 1.06165ZM15.4898 19.7609C15.9877 20.4247 16.5962 20.978 17.2048 21.4206C18.9751 22.5823 21.2433 22.9143 23.1797 23.2462C25.0053 23.5228 26.8863 23.7995 28.8226 23.9654C29.9291 21.3652 29.7631 18.4884 28.2694 16.3862C27.3842 15.2244 26.0565 14.2286 24.3415 13.62L15.4898 19.7609ZM20.7455 12.9008C18.0346 12.7902 15.3238 13.8966 14.7152 16.2202C14.4386 17.382 14.7153 18.4884 15.3238 19.4842L23.9542 13.454C23.401 13.3065 22.8477 13.159 22.2945 13.0114C21.7781 12.9377 21.2618 12.9008 20.7455 12.9008Z"
                  fill="#2E3341"
                  stroke="#2E3341"
                  strokeWidth="0.434734"
                />
              </svg>
              <div className="cert-underline"></div>
              <span className="cert-label">Pixaverse Studios</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Certificate;
